import {Component, DoCheck, OnInit, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {PlanModel} from '../../common/service/plan-model.model';
import {selectedPurpose} from '../../lodge-field-record/lodge-field-record.model';
import {NlrFieldRecordAttachmentsModal} from './field-record-attachments-modal.component';
import {NlrFieldRecordAttachmentsModalDataService} from './field-record-attachments-modalData.service';
import {NlrpLodgeFieldRecordService} from '../lodge-field-record.service';
import {AttachmentsModalService} from '../../common/component/modal/attachments-modal/attachments-modal.service';
import {AttachmentsViewModalService} from '../../common/component/modal/attachments-view-modal/attachments-view-modal.service';
import {AttachmentModel} from 'src/app/common/models/attachment-model';
import {HttpClient} from '@angular/common/http';
import {AppConfigService} from '../../common/service/app-config.service';
import {getMimeType} from '../../common/service/mime-type.utils';

@Component({
    selector: 'nlr-field-record-attachments',
    imports: [FormsModule, CommonModule, NlrFieldRecordAttachmentsModal],
    templateUrl: './field-record-attachments.component.html',
    styleUrl: './field-record-attachments.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FieldRecordAttachmentsComponent implements OnInit, DoCheck {
    planModel: PlanModel = undefined;
    attachmentTypes = undefined;
    previousPurpose = undefined;
    modalIsOpen = false;
    submitted = false;

    @Input()
    model: PlanModel;
    @Input()
    selectedPurpose: selectedPurpose;

    constructor(
        private http: HttpClient,
        private nlrFieldRecordAttachmentsModalDataService: NlrFieldRecordAttachmentsModalDataService,
        private nlrpLodgeFieldRecordService: NlrpLodgeFieldRecordService,
        private attachmentsModalService: AttachmentsModalService,
        private attachmentsViewModalService: AttachmentsViewModalService,
        private appConfigService: AppConfigService
    ) {}

    ngDoCheck(): void {
        if (this.model && this.model.purpose !== this.previousPurpose) {
            this.previousPurpose = this.model.purpose;
            const mandatoryAttachmentTypes = !!this.selectedPurpose.mandatoryAttachmentTypes ? this.selectedPurpose.mandatoryAttachmentTypes : [];
            const optionalAttachmentTypes = !!this.selectedPurpose.optionalAttachmentTypes ? this.selectedPurpose.optionalAttachmentTypes : [];

            this.model.attachments = this.attachmentTypes
                .filter(v => {
                    return mandatoryAttachmentTypes.indexOf(v.id) !== -1 || optionalAttachmentTypes.indexOf(v.id) !== -1;
                })
                .map(v => {
                    return {
                        type: v.id,
                        details: '',
                        status: mandatoryAttachmentTypes.indexOf(v.id) !== -1 ? 'Mandatory' : 'Optional'
                    };
                });
        }
    }
    ngOnInit(): void {
        this.nlrpLodgeFieldRecordService.getAttachmentTypes().subscribe(attachmentTypes => {
            this.attachmentTypes = attachmentTypes;
        });

        this.nlrFieldRecordAttachmentsModalDataService.getAttachmentsData().subscribe(data => {
            if (this.model) {
                this.model.attachments = data.attachments;
            }
        });
    }
    getAttachmentType(type: string) {
        return this.attachmentTypes.filter(v => {
            return v.id === type;
        })[0].name;
    }

    attach(index: number): boolean {
        const attachment = this.model.attachments[index];
        if (attachment.type == undefined) {
            return false;
        }

        const matchingAttachmentType = this.attachmentTypes.filter(function (v) {
            return v.id === attachment.type;
        })[0];

        if (matchingAttachmentType === undefined) {
            return false;
        }

        const extensions = matchingAttachmentType.extensions.split(' ');

        this.attachmentsModalService
            .showModal(extensions, 'FieldRecord', this.model.attachments, false, matchingAttachmentType.maxSize)
            .subscribe((data: AttachmentModel) => {
                attachment.url = data.url;
                attachment.uuid = data.uuid;
                attachment.fileName = data.fileName;
                attachment.fileSize = data.fileSize;
            });

        return true;
    }

    dismissModal() {
        this.modalIsOpen = false;
    }

    isFileNameValid(index: number) {
        if (this.model.attachments[index].status === 'Mandatory') {
            return this.model.attachments[index].fileName === undefined || this.model.attachments[index].fileName === '' ? false : true;
        }
        return true;
    }

    clear(index: number) {
        const attachment = this.model.attachments[index];
        this.model.attachments.splice(index, 1, {type: attachment.type, status: attachment.status});
    }

    view(index: number) {
        const attachment = this.model.attachments[index];
        const url = this.appConfigService.settings.apiGatewayUrl + '/attachment/getFieldRecordAttachment';

        this.http.post(url, attachment.uuid, {responseType: 'arraybuffer'}).subscribe(res => {
            const mimeType = getMimeType(attachment.fileName);
            const file = new Blob([res], mimeType);
            const fileURL = URL.createObjectURL(file);
            this.attachmentsViewModalService.showModal(fileURL, attachment.fileName, mimeType.type);
        });
    }
}
